var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chart-container"},[_c('chart',{attrs:{"height":_vm.height1,"width":_vm.width1,"path":_vm.path1,"id":_vm.id1,"chart_type":_vm.chart_type1,"params":_vm.params1,"lazy":true,"yAxisLabelBasePx":_vm.yAxisLabelBasePx1,"expand-bottom-axis":_vm.expandBottomAxis,"show_mode":_vm.show_mode1,"area_color":_vm.area_color1}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }